<template>
  <div class="page_two">
    <div class="wear1"></div>
    <div class="wear2"></div>
    <div class="content">
      <transition enter-active-class="animate__animated animate__fadeInUp">
        <div class="top" v-show="pageIndex == 1">
          <p class="p1">JOIN THE</p>
          <p class="p2">BATTLE OF THE ANCIENTS</p>
        </div>
      </transition>
      <div class="bottom">
        <div class="lvtiao"><img src="@/assets/img/lvtiao.png" alt="" /></div>
        <p class="p3">
          Miracle is one of Miracle Universe hero games. Miracle's development
          team and players will work together to create this miraculous world.
          Miracle will bring an immersive gaming experience, combined with a
          diversified ecosystem and active community interaction. This will
          attract many participants and continuously increase the value of
          assets.
        </p>
        <!-- <div class="btn">VIEW MORE</div> -->
        <div class="whitepaper">
          <a
            href="https://www.miracles.games/miracle/Whitepaper.pdf"
            target="blank"
            >Whitepaper</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "",
  computed: {
    ...mapState({
      pageIndex: (state) => state.page.pageIndex,
    }),
  },
};
</script>
<style scoped lang="scss">
.page_two {
  position: relative;
  // border: 1px solid #000;
  width: 100%;
  height: 1083px;
  background: url("~@/assets/img/beijing2.png") center top no-repeat;
  .wear1 {
    position: absolute;
    width: 100%;
    height: 4.734375rem;
    top: 0;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    background: url("~@/assets/img/middle_wear.png") center repeat-x;
    background-size: 0.666666rem 4.734375rem;
  }
  .wear2 {
    position: absolute;
    width: 100%;
    height: 4.734375rem;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(50%);
    background: url("~@/assets/img/middle_wear.png") center repeat-x;
    background-size: 0.666666rem 4.734375rem;
  }
  .content {
    z-index: 99;
    position: absolute;
    top: 615px;
    left: 5rem;
    transform: translateX(-50%);
    width: 1332px;
    height: 512px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: icomoon;
    .top {
      .p1 {
        width: 100%;
        height: 69px;
        text-align: center;
        font-size: 80px;
        font-weight: 700;
        color: #c9c9c9;
      }
      .p2 {
        margin-top: 26px;
        width: 100%;
        height: 71px;
        color: #fff;
        font-weight: 700;
        font-size: 87px;
      }
    }
    .bottom {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 666px;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      .lvtiao {
        margin-top: 38px;
        width: 101px;
        height: 3px;
      }
      .p3 {
        margin-top: 52px;
        width: 1052px;
        height: 121px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
      }
      .btn {
        cursor: pointer;
        margin-top: 47px;
        width: 344px;
        height: 80px;
        border: 3px solid #bbbbbb;
        border-radius: 4px;
        font-size: 40px;
        font-weight: 700;
        text-align: center;
        line-height: 80px;
      }
      .whitepaper {
        cursor: pointer;
        margin-top: 45px;
        width: 344px;
        height: 80px;
        border: 3px solid #ffffff;
        border-radius: 4px;
        color: #fff;
        font-size: 42px;
        text-align: center;
        line-height: 80px;
        a {
          color: #fff;
        }
      }
    }
  }
}

@media (max-width: 1199px) {
  .page_two {
    position: relative;
    // border: 1px solid #000;
    width: 100vw;
    height: 11.2rem;
    background: url("~@/assets/img/beijing2.png") center top no-repeat;
    background-size: 20rem 11.2rem;
    .wear1 {
      position: absolute;
      width: 100%;
      height: 4.734375rem;
      top: 0;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      background: url("~@/assets/img/middle_wear.png") center repeat-x;
      background-size: 0.666666rem 4.734375rem;
    }
    .wear2 {
      position: absolute;
      width: 100%;
      height: 4.734375rem;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(50%);
      background: url("~@/assets/img/middle_wear.png") center repeat-x;
      background-size: 0.666666rem 4.734375rem;
    }
    .content {
      z-index: 99;
      position: absolute;
      top: 7.466667rem;
      left: 5rem;
      transform: translateX(-50%);
      width: 100%;
      height: 5.28rem;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: icomoon;
      .top {
        .p1 {
          width: 100%;
          height: 0.453333rem;
          text-align: center;
          font-size: 0.48rem;
          font-weight: 700;
          color: #c9c9c9;
        }
        .p2 {
          margin-top: 0.293333rem;
          width: 100%;
          height: 0.48rem;
          color: #fff;
          font-weight: 700;
          font-size: 0.586667rem;
        }
      }
      .bottom {
        width: 100%;
        height: 4rem;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .lvtiao {
          margin-top: 0px;
          width: 1.52rem;
          height: 0.053333rem;
          img {
            width: 1.52rem;
            height: 0.053333rem;
          }
        }
        .p3 {
          margin-top: 0.693333rem;
          width: 100%;
          // height: 1.92rem;
          font-size: 0.32rem;
          font-weight: 700;
          text-align: center;
        }
        .btn {
          cursor: pointer;
          margin-top: 0.48rem;
          width: 4rem;
          height: 0.96rem;
          border: 0.053333rem solid #bbbbbb;
          border-radius: 4px;
          font-size: 0.4rem;
          font-weight: 700;
          text-align: center;
          line-height: 0.96rem;
        }
        .whitepaper {
          cursor: pointer;
          margin-top: 0.293333rem;
          width: 2.293333rem;
          height: 0.533333rem;
          border: 0.026667rem solid #ffffff;
          border-radius: 4px;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          line-height: 0.533333rem;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .page_two {
    position: relative;
    // border: 1px solid #000;
    width: 100vw;
    height: 11.2rem;
    background: url("~@/assets/img/beijing2.png") center top no-repeat;
    background-size: 20rem 11.2rem;
    .wear1 {
      position: absolute;
      width: 100%;
      height: 4.734375rem;
      top: 0;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      background: url("~@/assets/img/middle_wear.png") center repeat-x;
      background-size: 0.666666rem 4.734375rem;
    }
    .wear2 {
      position: absolute;
      width: 100%;
      height: 4.734375rem;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(50%);
      background: url("~@/assets/img/middle_wear.png") center repeat-x;
      background-size: 0.666666rem 4.734375rem;
    }
    .content {
      z-index: 99;
      position: absolute;
      top: 7.466667rem;
      left: 5rem;
      transform: translateX(-50%);
      width: 100%;
      height: 5.28rem;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: icomoon;
      .top {
        .p1 {
          width: 100%;
          height: 0.453333rem;
          text-align: center;
          font-size: 0.48rem;
          font-weight: 700;
          color: #c9c9c9;
        }
        .p2 {
          margin-top: 0.293333rem;
          width: 100%;
          height: 0.48rem;
          color: #fff;
          font-weight: 700;
          font-size: 0.586667rem;
        }
      }
      .bottom {
        width: 100%;
        height: 4rem;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .lvtiao {
          margin-top: 0px;
          width: 1.52rem;
          height: 0.053333rem;
          img {
            width: 1.52rem;
            height: 0.053333rem;
          }
        }
        .p3 {
          margin-top: 0.693333rem;
          width: 100%;
          // height: 1.92rem;
          font-size: 0.32rem;
          font-weight: 700;
          text-align: center;
        }
        .btn {
          cursor: pointer;
          margin-top: 0.48rem;
          width: 4rem;
          height: 0.96rem;
          border: 0.053333rem solid #bbbbbb;
          border-radius: 4px;
          font-size: 0.4rem;
          font-weight: 700;
          text-align: center;
          line-height: 0.96rem;
        }
        .whitepaper {
          cursor: pointer;
          margin-top: 0.293333rem;
          width: 2.293333rem;
          height: 0.533333rem;
          border: 0.026667rem solid #ffffff;
          border-radius: 4px;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          line-height: 0.533333rem;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page_two {
    position: relative;
    // border: 1px solid #000;
    width: 100vw;
    height: 11.2rem;
    background: url("~@/assets/img/beijing2.png") center top no-repeat;
    background-size: 20rem 11.2rem;
    .wear1 {
      position: absolute;
      width: 100%;
      height: 4.734375rem;
      top: 0;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      background: url("~@/assets/img/middle_wear.png") center repeat-x;
      background-size: 0.666666rem 4.734375rem;
    }
    .wear2 {
      position: absolute;
      width: 100%;
      height: 4.734375rem;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(50%);
      background: url("~@/assets/img/middle_wear.png") center repeat-x;
      background-size: 0.666666rem 4.734375rem;
    }
    .content {
      z-index: 99;
      position: absolute;
      top: 7.466667rem;
      left: 5rem;
      transform: translateX(-50%);
      width: 100%;
      height: 5.28rem;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: icomoon;
      .top {
        .p1 {
          width: 100%;
          height: 0.453333rem;
          text-align: center;
          font-size: 0.48rem;
          font-weight: 700;
          color: #c9c9c9;
        }
        .p2 {
          margin-top: 0.293333rem;
          width: 100%;
          height: 0.48rem;
          color: #fff;
          font-weight: 700;
          font-size: 0.586667rem;
        }
      }
      .bottom {
        width: 100%;
        height: 4rem;
        position: absolute;
        bottom: 0.266667rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .lvtiao {
          margin-top: 0px;
          width: 1.52rem;
          height: 0.053333rem;
          img {
            width: 1.52rem;
            height: 0.053333rem;
          }
        }
        .p3 {
          margin-top: 0.993333rem;
          width: 100%;
          // height: 1.92rem;
          font-size: 0.32rem;
          font-weight: 700;
          text-align: center;
        }
        .btn {
          cursor: pointer;
          margin-top: 0.68rem;
          width: 4rem;
          height: 0.96rem;
          border: 0.053333rem solid #bbbbbb;
          border-radius: 4px;
          font-size: 0.4rem;
          font-weight: 700;
          text-align: center;
          line-height: 0.96rem;
        }
        .whitepaper {
          cursor: pointer;
          margin-top: 0.293333rem;
          width: 2.293333rem;
          height: 0.8rem;
          border: 0.026667rem solid #ffffff;
          border-radius: 4px;
          color: #fff;
          font-size: 0.32rem;
          text-align: center;
          line-height: 0.8rem;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
